package com.narbase.letsgo.web.network
import kotlin.js.JsExport

/**
 * Created by Me on 17/02/2017.
 */

@JsExport
open class BasicResponse {
    var status: String? = null
}
